<template>
  <v-col
    cols="12"
    md="6"
  >
    <v-card
      outlined
      class="pa-4"
      style="overflow:auto"
    >
      <p class="title">
        Обращения за прошлый день
      </p>

      <svg
        width="100%"
        height="400"
      >
        <g transform="translate(40,-100)">
          <g
            class="x axis"
            transform="translate(0,450)"
          >

            <g
              v-for="(time, i) in timeInterval"
              :key="i"
              class="tick"
              :transform="`translate(${60.5 + (i- 1) * 34},0)`" style="opacity: 1;"
            >
              <text
                dy=".71em"
                y="9" x="0" style="text-anchor: middle;"
              >{{ time }}</text>
            </g>

          </g>
          <g class="y axis">
            <g
              v-for="i in 13"
              :key="i"
              class="tick"
              :transform="`translate(0,${480 - i * 31})`" style="opacity: 1;"
            ><line
               x2="-6"
               y2="0"
             />
              <text
                dy=".32em"
                x="-9" y="0" style="text-anchor: end;"
              >{{ i - 1 }}</text>
            </g>

            <path
              d="M-0,0H0V450H-1"
            />
          </g>

          <rect
            class="bar"
            x="10" width="31" y="160.66367501180912"
            height="289.3363249881909"
          />
          <rect
            class="bar"
            x="44" width="31" y="397.1421823334908"
            height="52.85781766650922"
          />
          <rect
            class="bar"
            x="78" width="31" y="351.4407179971658"
            height="98.55928200283421"
          />
          <rect
            class="bar"
            x="112" width="31" y="299.3268776570619"
            height="150.6731223429381"
          />
          <rect
            class="bar"
            x="146" width="31" y="220"
            height="230"
          />
          <rect
            class="bar"
            x="180" width="31" y="368.94189891355694"
            height="81.05810108644306"
          />
          <rect
            class="bar"
            x="214" width="31" y="378.61360415682566"
            height="71.38639584317434"
          />
          <rect
            class="bar"
            x="248" width="31" y="234.10486537553143"
            height="215.89513462446857"
          />
          <rect
            class="bar"
            x="282" width="31" y="203.21209258384505"
            height="246.78790741615495"
          />
          <rect
            class="bar"
            x="316" width="31" y="444.57959376476146"
            height="5.420406235238545"
          />
          <rect
            class="bar"
            x="350" width="31" y="422.64997638167216"
            height="27.35002361832784"
          />
          <rect
            class="bar"
            x="384" width="31" y="307.4043457723193"
            height="142.5956542276807"
          />

        </g>
      </svg>
    </v-card>
  </v-col>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed:{
    timeInterval() {
      const hours = Array.from({ length:12 }).map((_, index) => `${index * 2 < 9 ?  `0${index * 2}` : index * 2}:00`);
      return hours;
    },
  },

};
</script>

<style lang="scss">
.bar {
  fill: #d81c3f;
}

.bar:hover {
  fill: darkgray;
}

.axis {
  font: 10px sans-serif;
}

.axis path,
.axis line {
  fill: none;
  stroke: #000;
  shape-rendering: crispEdges;
}

.x.axis path {
  display: none;
}
</style>
